export default __webpack_public_path__ + "static/media/canada-flag-3x.d3a69784.png";